var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_cart_wrap"},[_c('router-link',{attrs:{"to":"/bag"}},[_c('span',{staticClass:"header_cart_counter"},[_vm._v(_vm._s(_vm.count))])])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff5f4be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/bag/BagIcon.vue
// module id = 445
// module chunks = 187